import React, { useState } from "react";
import { Select } from "antd";
import moment from "moment";
const { Option } = Select;

const CustomMonthDaysSelection = (props) => {
  const { onChange, date, disablePicker, ...rest } = props;
  const [monthDays, setMonthDays] = useState([]);

  const [open, setOpen] = useState(false);

  useState(() => {
    if (date) {
      setMonthDays(moment(date).daysInMonth());
    }
  }, [date]);

  const onBlur = (e) => {
    if (!disablePicker) {
      setOpen(false);
    }
  };
  const onFocus = () => {
    if (!disablePicker) {
      setOpen(true);
    }
    var currInput = document.activeElement;
    currInput.select();
  };

  const getSelection = () => {
    let days = [];
    for (var i = 1; i < monthDays + 1; i++) {
      const name = i > 9 ? i : `0${i}`;
      days.push(<Option value={i} key={i}>{`${name}`}</Option>);
    }
    return days;
  };

  return (
    <Select
      {...rest}
      showSearch
      open={open && !disablePicker}
      style={{ width: "60px" }}
      onBlur={onBlur}
      onFocus={onFocus}
      optionFilterProp="children"
      onChange={onChange}
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          const pickerValue = moment(e.target.value, "DD", true);
          if (pickerValue.isValid()) {
            onChange(e.target.value);
          }
        }
      }}
      value={
        date &&
        moment(date) &&
        moment(date).isValid() &&
        moment(date).toDate().getDate()
      }
    >
      {getSelection()}
    </Select>
  );
};

export default CustomMonthDaysSelection;
